export const MODULE_ARBEITSMITTEL_COLOR = '#c9a470'
// Vorschlag: export const MODULE_ARBEITSMITTEL_COLOR = '#D97706'
export const MODULE_ANALYSEN_COLOR = '#c583b9'
// Vorschlag: export const MODULE_ANALYSEN_COLOR = '#9333EA'
export const MODULE_AUFGABEN_COLOR = '#1976d2'
// Vorschlag: export const MODULE_AUFGABEN_COLOR = '#2563EB'
export const MODULE_MANAGEMENT_COLOR = '#de0613'
// Vorschlag: export const MODULE_MANAGEMENT_COLOR = '#DC2626'
export const MODULE_MITARBEITER_COLOR = '#ef8a4b'
// Vorschlag: export const MODULE_MITARBEITER_COLOR = '#EA580C'
export const MODULE_NOTIZEN_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_ORGANISATION_COLOR = '#00943f'
// Vorschlag: export const MODULE_ORGANISATION_COLOR = '#059669'
export const MODULE_PRAEVENTION_COLOR = MODULE_ANALYSEN_COLOR
export const MODULE_PROJEKTE_COLOR = '#1c5d98'
// Vorschlag: export const MODULE_PROJEKTE_COLOR = '#4F46E5'
export const MODULE_STAMMDATEN_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_DATEIEN_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_VERWALTUNG_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_ADMINISTRATION_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_LIEGENSCHAFTEN_COLOR = '#00838f'
// Vorschlag: export const MODULE_LIEGENSCHAFTEN_COLOR = '#0891B2'
export const MODULE_TICKETSYSTEM_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_BERICHTE_COLOR = MODULE_AUFGABEN_COLOR
export const MODULE_SCHULUNGSORGANISATION_COLOR = '#00796B'
// Vorschlag: export const MODULE_SCHULUNGSORGANISATION_COLOR = '#0D9488'
// Vertrieb hat noch kein eigenes Modul in den Stammdaten und damit keine eigene Farbe.
export const MODULE_VERTRIEB_COLOR = MODULE_ORGANISATION_COLOR

export const MODULE_ORGANISATION = 1
export const MODULE_MANAGEMENT = 2
export const MODULE_MITARBEITER = 3
export const MODULE_ARBEITSMITTEL = 4
export const MODULE_PRAEVENTION = 5
export const MODULE_PROJEKTE = 6
export const MODULE_AUFGABEN = 7
export const MODULE_LIEGENSCHAFTEN = 8
export const MODULE_TICKETSYSTEM = 9
export const MODULE_HISTORY = 10
export const MODULE_SCHULUNGSORGANISATION = 11
export const MODULE_ANALYSEN = 12
export const MODULE_SIGNATURES = 13
export const MODULE_EMAILING = 14
export const MODULE_BERICHTE = 15

// Globale Action Positionen
export const ADD_ACTION_ORDER = 0
export const SAVE_ACTION_ORDER = 1
export const PROZESS_ACTION_ORDER = 6
export const ANALYSE_ACTION_ORDER = 7
export const FULLSCREEN_ACTION_ORDER= 8
export const REFRESH_ACTION_ORDER = 9
export const FILTER_ACTION_ORDER = 10
export const SHOW_HISTORY_ACTION_ORDER = 14
export const DUPLICATE_ACTION_ORDER = 15
export const SHOW_DELETED_ACTION_ORDER = 16
export const DATENFILTER_INFO_ACTION_ORDER = 17
export const SHOW_MAP_ORDER = 21
export const EXCELEXPORT_ACTION_ORDER = 22
export const EXCELEXPORT_ANSPRECHPERSONEN_ACTION_ORDER = 23
export const EXCELEXPORT_CHECKLISTEN_ACTION_ORDER = 23
export const EXCELEXPORT_KURSE_HOPPE_ACTION_ORDER = 23
export const EXCELEXPORT_PERSONEN_WINASPED_ACTION_ORDER = 23
export const SIGNATUREN_EINHOLEN_ACTION_ORDER = 26
export const PROJEKTE_IMPORT_ACTION_ORDER = 28

// 3-Punkte-Menü (Record/Detail) – kanonische Reihenfolge, in jedem Modul identisch (asix/organisation#13062)
// Aufbau: "Vollständigen Datensatz öffnen" -> Report -> modul-eigene Aktionen (bestehende Orders, < 60)
//         -> Trenner (prependDivider auf QR-Code) -> Default-Block (QR, Favoriten, Übersetzen, Historie, Löschen)
// Der Default-Block liegt bewusst in einem hohen Band (60+), damit ALLE modul-spezifischen
// Aktionen (Orders 1–49) automatisch oberhalb des Trenners in Block 1 landen.
// "Vollständigen Datensatz öffnen" ist keine Modul-Aktion, sondern der Sprung aus dem Dialog in
// den vollen Datensatz und steht deshalb noch über Report (negativ, damit das Modul-Band 1–49
// und Report=0 unverändert bleiben) – asix/organisation#13552.
export const RECORD_MENU_VOLLSTAENDIGER_DATENSATZ_ORDER = -1
export const RECORD_MENU_REPORT_ORDER = 0
export const RECORD_MENU_QRCODE_ORDER = 60
export const RECORD_MENU_FAVORITEN_ORDER = 61
export const RECORD_MENU_UEBERSETZEN_ORDER = 62
export const RECORD_MENU_HISTORIE_ORDER = 63
export const RECORD_MENU_LOESCHEN_ORDER = 64

// Objektbezogene Aktionen stehen vor den allgemeinen Listen-Aktionen (Gelöschte Objekte 16,
// Datenfilter Info 17, Karten-Dialog 21, Excel Export 22/23). Vorher lagen die beiden
// Mitarbeiter-Aktionen mit 30/31 dahinter und wurden dadurch von ihnen getrennt
// (Review-Hinweis zu asix/organisation#13552).
// Mitarbeiter: Ausbildungsdokumente-Aktion, einheitlich über die Detail-Forms
export const MITARBEITER_AUSBILDUNGSDOKUMENTE_ORDER = 11

// Weitere modul-eigene 3-Punkte-Menü-Aktionen (Modul-Block 1–49) – benannte Orders statt Literale (asix/organisation#13062)
export const MITARBEITER_ACTION_OBJEKTE_VERSCHIEBEN = 12
export const VISITENTERMIN_ACTION_ARBEITSMEDIZINER_EXPORT = 30
export const ANALYSEANFORDERUNG_ACTION_ANALYSE_OEFFNEN = 20
export const BENUTZER_ACTION_PASSWORT_ZURUECKSETZEN = 1
export const BENUTZER_ACTION_DUPLIZIEREN = 3
export const AUFGABENVORLAGE_ACTION_AUFGABE_ERSTELLEN = 7
export const AUFGABENVORLAGE_ACTION_UEBERNEHMEN = 8
export const AUFGABENVORLAGE_ACTION_QR_CODES_FUER_OBJEKTE = 9
export const AUFGABENVORLAGE_ACTION_FAVORIT_ERSTELLEN = 28

// Verwaltung Benutzer
export const HISTORY_ACTION_OF_USER = 4
export const EMAILBENACHRICHTIGUNG_TYP_AUFGABE = 0
export const EMAILBENACHRICHTIGUNG_TYP_SCHULUNG = 1
export const EMAILBENACHRICHTIGUNG_TYP_KURSE = 2
export const EMAILBENACHRICHTIGUNG_TYP_SCHNITTSTELLE = 3
export const EMAILBENACHRICHTIGUNG_TYP_DOKUMENTE = 4
export const EMAILBENACHRICHTIGUNG_TYP_QUALIFIKATIONEN = 5

export const EMAILBENACHRICHTIGUNG_TYPES = [
  EMAILBENACHRICHTIGUNG_TYP_AUFGABE,
  EMAILBENACHRICHTIGUNG_TYP_SCHULUNG,
  EMAILBENACHRICHTIGUNG_TYP_KURSE,
  EMAILBENACHRICHTIGUNG_TYP_SCHNITTSTELLE,
  EMAILBENACHRICHTIGUNG_TYP_DOKUMENTE,
  EMAILBENACHRICHTIGUNG_TYP_QUALIFIKATIONEN,
]

// Aufgaben
export const AUFGABEN_ACTION_ABSCHLIESSEN = 4
export const AUFGABEN_ACTION_MILESTONE_SETZEN = 5
export const AUFGABEN_ACTION_CHECKLISTE_HINZUFUEGEN = 6
export const AUFGABEN_ACTION_ABONNIEREN = 7
export const AUFGABEN_ACTION_PROJEKT_ZUWEISEN = 8
export const AUFGABEN_ACTION_PROJEKTAUFGABEN_HISTORIE = 9

// Dokumente
export const DOKUMENTE_ACTION_NACHWEISDOKUMENTE = 4
export const DOKUMENTE_ACTION_VEROEFFENTLICHUNGEN = 5
export const DOKUMENTE_ACTION_VEROEFFENTLICHUNGEN_AENDERN = 6
export const DOKUMENTE_ACTION_VEROEFFENTLICHUNGEN_AUFHEBEN = 6
export const DOKUMENTE_ACTION_BERICHT_ERSTELLEN = 6
export const DOKUMENTE_ACTION_BERICHT_AKTUALISIEREN = 7
export const DOKUMENTE_ACTION_SIGNIEREN = 8
export const DOKUMENTE_ACTION_DOWNLOAD = 9
export const DOKUMENTE_ACTION_DOWNLOAD_DOKUMENT_UND_ZERTIFIKATE = 10
export const DOKUMENTE_ACTION_ARCHIVIEREN = 11
export const DOKUMENTE_ACTION_DATENSAETZE_SPERREN = 12
export const DOKUMENTE_ACTION_DATENSAETZE_ENTSPERREN = 13
export const DOKUMENTE_ACTION_SIGNATURPROZESS_ERINNERUNGSMAIL = 14
export const DOKUMENTE_ACTION_SIGNATURPROZESS_STARTEN = 15

// Kurse
export const KURSE_ACTION_AUSBILDUNGSNACHWEISE_GENERIEREN = 20

// Dokumente List
export const DOKUMENT_SPERREN_ACTION_ORDER = 6
export const DOKUMENT_ENTSPERREN_ACTION_ORDER = 7

// Arbeitsmittel
export const ARBEITSMITTEL_ACTION_ARBEITSMITTELUNTERLAGEN = 20

// Projekte
export const PROJEKTE_ACTION_PROJEKTUNTERLAGEN = 20

// Bilder
export const BILDER_ACTION_DOWNLOAD = 1
export const BILDER_ACTION_ROTATE_RIGHT = 2
export const BILDER_ACTION_ROTATE_LEFT = 3


// Bild Form
export const BILD_ACTION_LINKS_DREHEN = 3
export const BILD_ACTION_RECHTS_DREHEN = 4

// Schulungsorganisation
export const SCHULUNGSORGANISATION_ACTION_SCHULUNG_AUS_VORLAGE_ERSTELLEN = 1
export const SCHULUNGSORGANISATION_ACTION_VORLAGE_AUS_SCHULUNG_ERSTELLEN = 1
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSVORLAGE_AUSWAEHLEN = 1
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSDOKUMENTE_VEROEFFENTLICHEN = 1
export const SCHULUNGSORGANISATION_ACTION_REFERENTEN_MAIL_SENDEN = 1
export const SCHULUNGSORGANISATION_ACTION_OEFFENTLICHE_SCHULUNGSSEITE_OEFFNEN = 1
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSKONTAKT_VEREINIGEN = 1
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGEN_ABONNIEREN = 2
// Schulungsteilnehmer-Menü (Card + ListDialog)
export const SCHULUNGSORGANISATION_ACTION_TEILNEHMER_EINLADEN = 1
export const SCHULUNGSORGANISATION_ACTION_ABGELAUFENE_TEILNEHMER_ANZEIGEN = 2
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSKONTAKT_ABMELDEN = 3
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSKONTAKT_LOESCHEN = 4
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSTEILNEHMER_VERSCHIEBEN = 5
export const SCHULUNGSORGANISATION_ACTION_EMAIL_SENDEN = 6
export const SCHULUNGSORGANISATION_ACTION_TEILGENOMMEN_SETZEN = 7
export const SCHULUNGSORGANISATION_ACTION_PRUEFUNG_BESTANDEN_SETZEN = 8
// Einzelansicht (Form) eines Schulungsteilnehmers: direkter Mailversand für den geöffneten Teilnehmer
export const SCHULUNGSORGANISATION_ACTION_BESTAETIGUNGSMAIL_SENDEN = 5
export const SCHULUNGSORGANISATION_ACTION_ERINNERUNGSMAIL_SENDEN = 6
export const SCHULUNGSORGANISATION_ACTION_SCHULUNGSMODULDOKUMENTE_VEROEFFENTLICHEN = 21
export const SCHULUNGSORGANISATION_ACTION_DIGITALES_ANWESENHEITSREGISTER = 22

// Organisation
export const ORGANISATION_HAUPTUNTERNEHMEN_SETZEN = 4
// Mitarbeiter
export const MITARBEITER_OBJEKTE_VERSCHIEBEN = 4

export const MATRIXMOBIL_MODUS_TAETIGKEITEN = 0  // index vom Modus-Array
export const MATRIXMOBIL_MODUS_QUALIFIKATIONEN = 1  // index vom Modus-Array
export const MATRIXMOBIL_MODUS_FIELDS = [
  [
    {'field': 'mitarbeiter', 'display_name': 'Mitarbeiter'},
    {'field': 'berufsbezeichnung', 'display_name': 'Tätigkeiten'}
  ],
  [
    {'field': 'mitarbeiter', 'display_name': 'Mitarbeiter'},
    {'field': 'qualifikation', 'display_name': 'Qualifizierungen'}
  ]
]

// Dashboard
export const SCHULUNGSPLANUNG_QUALIFIKATION = 1
export const SCHULUNGSPLANUNG_MITARBEITER = 2

export const MODULE = {
  'Allgemein': 0,
  'Organisation': MODULE_ORGANISATION,
  'Management': MODULE_MANAGEMENT,
  'Mitarbeiter': MODULE_MITARBEITER,
  'Arbeitsmittel': MODULE_ARBEITSMITTEL,
  'Praevention': MODULE_PRAEVENTION,
  'Projekte': MODULE_PROJEKTE,
  'Aufgaben': MODULE_AUFGABEN,
  'Liegenschaften': MODULE_LIEGENSCHAFTEN,
  'Schulungsoraganisation': MODULE_SCHULUNGSORGANISATION,
  'Analysen': MODULE_ANALYSEN,
}

export const TOOLTIP_OPEN_DELAY = 500


export const SCHULUNGSORGANISATION_RECHAPTCHA_PUBLIC_KEY = '6LfiA3EpAAAAAN8bCCSumJFHqifc5Lxk0yCvNkPI'
